module.exports = __webpack_public_path__ + "img/askmebet-support.20dd385b.png";